import * as chains from './chains';

const MAINNETCoins = [
  
  {
    name: "Pulse",
    abbr: "PLS",
    address: "0xA1077a294dDE1B09bB078844df40758a5D0f9a27", 
    imageURI: ""
  },
  {
    name: "DEX",
    abbr: "DEX",
    address: "0x57953dAC106a4cDa11D90273b1B9D59E169533c0", 
    imageURI: ""
  },
  {
    name: "PulseX",
    abbr: "PLSX",
    address: "0x95B303987A60C71504D99Aa1b13B4DA07b0790ab",
    imageURI: ""
  },
  {
    name: "DAI from eth",
    abbr: "DAI",
    address: "0xefD766cCb38EaF1dfd701853BFCe31359239F305",
    imageURI: ""
  },
  {
    name: "HEX",
    abbr: "HEX",
    address: "0x2b591e99afE9f32eAA6214f7B7629768c40Eeb39",
    imageURI: ""
  },
  {
    name: "HEX BEAR",
    abbr: "HXB",
    address: "0x009a8670E74E1dda3E449E93A9308e5977949967",
    imageURI: ""
  },
  {
    name: "TETRA",
    abbr: "TETRA",
    address: "0xAeC4C07537B03E3E62fc066EC62401Aed5Fdd361",
    imageURI: ""
  },
  {
    name: "Hex Orange Address",
    abbr: "HOA",
    address: "0x7901a3569679AEc3501dbeC59399F327854a70fe",
    imageURI: ""
  },
  {
    name: "USDL",
    abbr: "USDL",
    address: "0x0dEEd1486bc52aA0d3E6f8849cEC5adD6598A162",
    imageURI: ""
  },
  {
    name: "Incentive",
    abbr: "INC",
    address: "0x2fa878Ab3F87CC1C9737Fc071108F904c0B0C95d",
    imageURI: ""
  },
  {
  name: "DAI Copy",
    abbr: "pDAI",
    address: "0x6B175474E89094C44Da98b954EedeAC495271d0F",
    imageURI: ""
  },
  {
    name: "Internet Money",
    abbr: "IM",
    address: "0xBBcF895BFCb57d0f457D050bb806d1499436c0CE",
    imageURI: ""
  },
  {
    name: "PEPE",
    abbr: "PEPE",
    address: "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
    imageURI: ""
  
  },
  {
    name: "Richard's Only Brother",
    abbr: "ROB",
    address: "0x1c2766F5949A4aA5d4cf0439067051135ffc1b28",
    imageURI: ""
  },
  {
    name: "pBear",
    abbr: "PBR",
    address: "0x425AEb3Be986442A2f317156d520130ac0d25E3e",
    imageURI: ""
  },
  {
    name: "Wrapped Pulse",
    abbr: "WPLS",
    address: "0xA1077a294dDE1B09bB078844df40758a5D0f9a27",
    imageURI: ""
  },
]


const COINS = new Map();
COINS.set(chains.ChainId.MAINNET, MAINNETCoins);

export default COINS
